"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHttpClient = void 0;
var tslib_1 = require("tslib");
var axios_1 = tslib_1.__importDefault(require("axios"));
var qs_1 = require("qs");
var createHttpClient = function (_a) {
    var baseUrl = _a.baseUrl, api_token = _a.api_token, defaultHeaders = _a.defaultHeaders;
    var buildQueryParams = function (queryParams) {
        return (0, qs_1.stringify)(tslib_1.__assign(tslib_1.__assign({}, queryParams), { api_token: api_token }), { addQueryPrefix: true, arrayFormat: 'comma' });
    };
    var buildUrl = function (endpoint, queryParams) {
        return "".concat(baseUrl).concat(endpoint).concat(buildQueryParams(queryParams));
    };
    var withDefaultHeaders = function (options) {
        var initialHeaders = {
            'content-type': 'application/json',
            accept: 'application/json',
        };
        return tslib_1.__assign(tslib_1.__assign({}, options), { headers: tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, initialHeaders), defaultHeaders), options.headers) });
    };
    var get = function (_a) {
        var endpoint = _a.endpoint, queryParams = _a.queryParams, _b = _a.options, options = _b === void 0 ? {} : _b;
        return axios_1.default.get(buildUrl(endpoint, queryParams), withDefaultHeaders(options));
    };
    var post = function (_a) {
        var endpoint = _a.endpoint, data = _a.data, queryParams = _a.queryParams, _b = _a.options, options = _b === void 0 ? {} : _b;
        return axios_1.default.post(buildUrl(endpoint, queryParams), data, withDefaultHeaders(options));
    };
    var put = function (_a) {
        var endpoint = _a.endpoint, data = _a.data, queryParams = _a.queryParams, _b = _a.options, options = _b === void 0 ? {} : _b;
        return axios_1.default.put(buildUrl(endpoint, queryParams), data, withDefaultHeaders(options));
    };
    var patch = function (_a) {
        var endpoint = _a.endpoint, data = _a.data, queryParams = _a.queryParams, _b = _a.options, options = _b === void 0 ? {} : _b;
        return axios_1.default.patch(buildUrl(endpoint, queryParams), data, withDefaultHeaders(options));
    };
    var remove = function (_a) {
        var endpoint = _a.endpoint, queryParams = _a.queryParams, _b = _a.options, options = _b === void 0 ? {} : _b;
        return axios_1.default.delete(buildUrl(endpoint, queryParams), withDefaultHeaders(options));
    };
    return {
        get: get,
        put: put,
        post: post,
        patch: patch,
        remove: remove,
    };
};
exports.createHttpClient = createHttpClient;
